import React, { useState, useRef, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import './Insights.css';
import { ROUTES } from '../../utils/routes';


/**
 * InsightsDetail Component
 * 
 * Displays a detailed view of a single insight
 * Now accepts optional onBack prop for backward compatibility,
 * but uses useNavigate by default if not provided
 */
export default function InsightsDetail({ insight, onBack }) {
  console.log("InsightsDetail component loaded");
  console.log(insight);
  const navigate = useNavigate();
  const { slug } = useParams();
  console.log(slug);
  const [openFaq, setOpenFaq] = useState(null);
  const [activeSection, setActiveSection] = useState(0);
  const contentSectionRefs = useRef([]);
  const sidebarRef = useRef(null);
  const [insightsData, setInsightsData] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    console.log("InsightsDetail component loaded");
    fetch(`${process.env.REACT_APP_API_URL}/insights-detail/${slug}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "api-username": `${process.env.REACT_APP_API_URL_USERNAME}`,
        "api-password": `${process.env.REACT_APP_API_URL_PASSWORD}`
      },
      body: JSON.stringify({})
    })
      .then((response) => response.json())
      .then((data) => {
        setInsightsData(data.insight);
      })
      .catch((error) => {
        console.log(error);
      }).finally(() => {
        setLoading(false);
      });
  }, []);
  useEffect(() => {
    const handleScroll = () => {
      contentSectionRefs.current.forEach((ref, index) => {
        if (ref) {
          const rect = ref.getBoundingClientRect();

          if (rect.top <= 150 && rect.bottom >= 150) {
            setActiveSection(index);
          }
        }
      });
    };

    const contentArea = document.querySelector(
      '.insight-detail-content-wrapper'
    );

    if (contentArea) {
      contentArea.addEventListener('scroll', handleScroll);

      return () => {
        contentArea.removeEventListener('scroll', handleScroll);
      };
    }
  }, []);
  // Use provided onBack or navigate back to insights using React Router
  const handleBack = () => {
    if (onBack) {
      onBack();
    } else {
      navigate(ROUTES.INSIGHTS);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };


  const handleSectionClick = (index) => {
    setActiveSection(index);

    const element = contentSectionRefs.current[index];

    if (element) {
      setTimeout(() => {
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }, 0);
    }
  };

  if (!insightsData) {
    return (
      <div className="insights-page">
        <div className="container" style={{ padding: 40 }}>
          <button className="back-button" onClick={handleBack}>
            <i className="bi bi-arrow-left" /> Back to insights
          </button>

          <p style={{ marginTop: 16 }}>
            No insight selected.
          </p>
        </div>
      </div>
    );
  }
  return (
    <div className="insights-page">
      <div className="insight-detail-breadcrumb-wrap">
        <div className="container">
          <nav
            className="insight-detail-breadcrumb"
            aria-label="Breadcrumb"
          >
            <button
              type="button"
              className="breadcrumb-home"
              onClick={handleBack}
            >
              <i className="bi bi-house" /> Insights
            </button>

            <span className="breadcrumb-sep">
              <i className="bi bi-chevron-right" />
            </span>

            <span className="breadcrumb-current">
              {insightsData.name}
            </span>
          </nav>
        </div>
      </div>
      <section className="insight-detail-section">
        <div className="container">
          <div className="insight-detail-top-section">
            <div className="insight-detail-media-wrapper">
              <div className="insight-detail-image-container">

                <img
                  src={`${process.env.REACT_APP_IMAGE_BASE_URL}/${insightsData.folder_path}/${insightsData.image}`}
                  alt={insightsData.name}
                  className="insight-detail-image"
                  loading="lazy"
                />
              </div>
            </div>

            <div className="insight-detail-top-content">
              <div className="insight-detail-header">
                <div className="insight-detail-badges">
                  {/* <span className="insight-detail-category">
                    {insightsData.category.name}
                  </span> */}

                  <span className="insight-detail-type">
                    {insightsData.type}
                  </span>
                </div>

                <h1 className="insight-detail-title">
                  {insightsData.name}
                </h1>
              </div>

              <div className="insight-published-date">Published by {insightsData.posted_by}, {insightsData.posted_date}</div>


              <div className="insight-detail-description-box">
                <div dangerouslySetInnerHTML={{ __html: insightsData.description }} />
              </div>
            </div>
          </div>

          {/* KEEP THE REST OF YOUR EXISTING CODE EXACTLY THE SAME */}

          {/* BOTTOM SECTION - Sidebar + Content Layout */}
          <div className="insight-detail-wrapper-sidebar">
            {/* Left Sidebar - Sticky */}
            <aside className="insight-detail-sidebar" ref={sidebarRef}>
              <div className="insight-detail-sidebar-sticky">
                <div className="insight-sidebar-sections">
                  <h3 className="sidebar-sections-title">What's on this page</h3>
                  <nav className="sidebar-nav">
                    {insightsData.what_on_this_page && insightsData.what_on_this_page.map((section, index) => (
                      <button
                        key={index}
                        className={`sidebar-nav-item ${activeSection === index ? 'active' : ''}`}
                        onClick={() => handleSectionClick(index)}
                      >
                        {section.title}
                        <span className="sidebar-nav-indicator" />
                      </button>
                    ))}
                    {/* FAQ Navigation Item */}
                    {insightsData.faq && insightsData.faq.length > 0 && (
                      <button
                        className={`sidebar-nav-item ${activeSection === 'faq' ? 'active' : ''}`}
                        onClick={() => {
                          setActiveSection('faq');
                          const faqElement = document.querySelector('.insight-detail-faq');
                          if (faqElement) {
                            setTimeout(() => {
                              faqElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
                            }, 0);
                          }
                        }}
                      >
                        FAQ
                        <span className="sidebar-nav-indicator" />
                      </button>
                    )}
                  </nav>
                </div>
              </div>
            </aside>

            {/* Right Content Area */}
            <div className="insight-detail-content-wrapper">
              {/* Content Sections */}
              {insightsData.what_on_this_page && insightsData.what_on_this_page.length > 0 && (
                <div className="insight-sections-container">
                  {insightsData.what_on_this_page.map((section, index) => (
                    <section
                      key={index}
                      className="insight-content-section"
                      ref={(el) => (contentSectionRefs.current[index] = el)}
                    >
                      <div className="section-header">
                        <h2 className="section-title">{section.title}</h2>
                      </div>
                      <div className="section-content">
                        <div dangerouslySetInnerHTML={{ __html: section.description }} />
                      </div>
                    </section>
                  ))}
                </div>
              )}

              {/* FAQ Section */}
              {insightsData.faq && insightsData.faq.length > 0 && (
                <section className="insight-detail-faq">
                  <div className="section-header">
                    <h2 className="section-title">Frequently Asked Questions</h2>

                  </div>
                  <div className="faq-items-wrapper">
                    {insightsData.faq.map((f, idx) => (
                      <div className="faq-item-wrapper" key={idx}>
                        <button
                          className={`faq-question ${openFaq === idx ? 'open' : ''}`}
                          onClick={() => setOpenFaq(openFaq === idx ? null : idx)}
                        >
                          <span className="faq-q-text">{f.question}</span>
                          <span className="faq-toggle-icon">
                            <i className={`bi bi-chevron-${openFaq === idx ? 'up' : 'down'}`} />
                          </span>
                        </button>
                        {openFaq === idx && (
                          <div className="faq-answer">
                            <p>{f.answer}</p>
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                </section>
              )}


              <div className="insight-detail-footer">
                <button className="back-button" onClick={onBack}>
                  <i className="bi bi-arrow-left" /> Back to insights
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
